// extracted by mini-css-extract-plugin
var _1 = {"name":"SITE-HeadedPage"};
var _2 = {"body":"SITE-HeadedPage__body","header":"SITE-HeadedPage__header","shadow":"SITE-HeadedPage__shadow"};
var _3 = {};
export { _1 as "b", _2 as "e", _3 as "m" }
